import { isGlobalParent, isGlobalChild, getGlobalId } from './node'
import { resolver } from 'react-pagebuilder/editor'

export const canDrag = (currentNode, helpers, fun) => {
  if (currentNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(currentNode, helpers)
  } else {
    return true
  }
}

export const canDrop = (targetNode, helpers, fun) => {
  if (targetNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(targetNode, helpers)
  } else {
    return true
  }
}

export const canMoveIn = (incomingNodes, currentNode, helpers, fun) => {
  if (currentNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(incomingNodes, currentNode, helpers)
  } else {
    return true
  }
}

export const canMoveOut = (outgoingNode, currentNode, helpers, fun) => {
  if (outgoingNode.data.props.conditions.disabled) {
    return false
  }

  if (fun) {
    return fun(outgoingNodes, currentNode, helpers)
  } else {
    return true
  }
}

export const canDropBlock = (currentNode, targetNode) => {
  const Block = resolver[targetNode.data.name]

  if (Block) {
    return Block.craft.rules.canMoveIn([currentNode], targetNode)
  }

  return false
}
